<template>
  <div class="feature_facilities">
    <h3 class="facilities_support">各フロアの診療科目のご紹介です。</h3>
    <!-- <p class="facilities_subject" v-html="expert"></p> -->
    <ul class="facilities_list list list_floor">
      <li v-for="list in lists" v-html="list"></li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'FeatureFacilities',
  props: {
    msg: String,
    lists: Array
  },
  data () {
    return {
      expert: siteData.detail.expert.join('・')
    }
  },
  computed: {
    ...mapState([
      'siteData'
    ])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
